import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIcedMasterData, getIcedTableData, updateIcedDataStart } from "../../../actions/Applications/aquaa.action";
import SingleSelectDropdown from "../../Reusable components/SingleSelect/SingleSelectDropdown";
import { Box, TextField } from "@material-ui/core";
import './Iced.css';
import AdminBreadcrumb from "../../../components/Administration/General/Admin-breadcrumb";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Iced = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const icedMasterData = useSelector((state) => state.aquaaReducer.icedMasterData);
  const icedTableData = useSelector((state) => state.aquaaReducer.icedTableData);

  const data = icedMasterData?.[0] || {};
  const channels = data.Channel || [];
  const ticketSources = data.TicketSource || [];
  const contactType = data.ContactType || [];
  const serviceTowerList = data.ServiceTower || [];
  const serviceTowerDefault = data.ServiceTowerDefault?.[0]?.ServiceTowerValue || "";
  const customerServicedesk = data.CustomerServicdesk || [];
  const languageData = data.LanguageCustomerServicedesk || [];
  const languageDefault = data.LanguageDefault?.[0] || {};
  const RoleId = localStorage.getItem('Role_id');

  // ---------- States ----------
  const [selectedChannel, setSelectedChannel] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedTicketSource, setSelectedTicketSource] = useState("");
  const [selectedContactType, setSelectedContactType] = useState("Inbound");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedServiceTower, setSelectedServiceTower] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedTicketNumber, setSelectedTicketNumber] = useState("");
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [validation, setValidation] = useState('')

  const [searchQuery, setSearchQuery] = useState({
    country: "",
    account: "",
    serviceTower: "",
    language: "",
    ticketNumber: "",
  });

  useEffect(() => {
    dispatch(getIcedMasterData(RoleId));
    dispatch(getIcedTableData())
  }, [dispatch,RoleId]);

  console.log('icedTableData', icedTableData)

  // const countryOptions = customerServicedesk.map((item) => item.Servicedesk) || [];

  //  const matched = customerServicedesk.find(
  //   (item) => item.Servicedesk === selectedCountry
  // );

  // const accountOptions = matched
  //   ? matched.Customers.map((cust) => cust) // return full customer object
  //   : [];

  const countryOptions = languageData || [];

  const matchedCountry = languageData.find(
    (item) => item.Servicedesk === selectedCountry?.Servicedesk
  );

  const accountOptions = matchedCountry?.Customer || [];

  // const accountOptions =
  // customerServicedesk.find(item => item.Servicedesk === selectedCountry)
  //   ?.Customers || [];

  const serviceTowerOptions = serviceTowerList.map((st) => st.ServiceTower) || [];

  const languageDropdownOptions = React.useMemo(() => {
    const base =
      matchedCountry?.Customer.find(
        (cust) => cust.Customer === selectedAccount?.Customer
      )?.Language || [];

    // fallback to default
    if (base.length === 0 && languageDefault?.LanguageID) {
      return [languageDefault];
    }

    return base;
  }, [selectedAccount, languageDefault, matchedCountry]);

  // const languageDropdownOptions = React.useMemo(() => {
  //   const base =
  //     languageData
  //       .find((lang) => lang.Servicedesk === selectedCountry)
  //       ?.Customer.find((cust) => cust.Customer === selectedAccount)
  //       ?.Language.map((l) => ({
  //         id: l.LanguageID,
  //         label: l.Language || l.LanguageValue,
  //       })) || [];

  //   if (base.length === 0 && languageDefault?.LanguageID) {
  //     return [
  //       {
  //         id: languageDefault.LanguageID,
  //         label: languageDefault.LanguageValue,
  //       },
  //     ];
  //   }

  //   return base;
  // }, [languageData, selectedCountry, selectedAccount, languageDefault]);

  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let timer;
    if (isRunning) {
      timer = setInterval(() => setSeconds((prev) => prev + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [isRunning]);

  const handleStart = () => {
    setIsRunning(true);
    setStartDateTime(formatDateTime(new Date()));
  };
  const handlePause = () => setIsRunning(false);

  const formatTime = (totalSeconds) => {
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const channelData = channels.find((c) => c.ChannelName === selectedChannel);

  useEffect(() => {
    if (serviceTowerDefault && !selectedServiceTower) {
      setSelectedServiceTower(serviceTowerDefault);
    }

    if (languageDefault?.LanguageID && !selectedLanguage) {
      const defaultLang = languageDropdownOptions.find(
        (l) => l.id === languageDefault.LanguageID
      );
      if (defaultLang) setSelectedLanguage(defaultLang);
    }
  }, [serviceTowerDefault, languageDefault, languageDropdownOptions, selectedLanguage, selectedServiceTower]);

  const formatDateTime = (date) => {
    const pad = (num, size = 2) => String(num).padStart(size, "0");
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());
    const ms = String(date.getMilliseconds()).padStart(3, "0");
    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}.${ms}`;
  };

 const resetForm = () => {
  setSelectedChannel("");
  setSelectedValue("");
  setSelectedTicketSource("");
  setSelectedContactType("Inbound");
   setSelectedCountry(null);     
  setSelectedAccount(null);       
  setSelectedServiceTower(serviceTowerDefault || ""); 
  setSelectedLanguage(null);    

  setSelectedTicketNumber("");

  setSeconds(0);
  setIsRunning(false);
  setStartDateTime(null);
  setEndDateTime(null);

  setValidation("");

  setSearchQuery({
    country: "",
    account: "",
    serviceTower: "",
    language: "",
    ticketNumber: "",
  });
};



  const handleSubmit = () => {
    const formattedEnd = formatDateTime(new Date());
    setEndDateTime(formattedEnd);

    const payload = [
      {
        StartDate: startDateTime,
        EndDate: formattedEnd,
        Duration: formatTime(seconds),
        TicketNumber: selectedTicketNumber,
        Contact: selectedContactType,
        Channel: selectedChannel,
        Value: selectedValue,
        TicketSource: selectedTicketSource,
        ServiceTower: selectedServiceTower,
        LanguageID: selectedLanguage?.LanguageID,
        CountryID: selectedCountry?.CountryID,
        AccountID: selectedAccount?.AccountID,
      },
    ];

    const temp_Arr = {
      TicketNumber: selectedTicketNumber,
      Contact: selectedContactType,
      Channel: selectedChannel,
      Value: selectedValue,
      TicketSource: selectedTicketSource,
      ServiceTower: selectedServiceTower,
      LanguageID: selectedLanguage?.LanguageID,
      CountryID: selectedCountry?.CountryID,
      AccountID: selectedAccount?.AccountID,
    }
    const isEmptyInput = Object.values(temp_Arr).some(x => (x === null || x === '' || x === undefined));
    if (isEmptyInput) {
      setValidation('Please Ensure you filled all the inputs')
    }
    else {
      setValidation('')
      dispatch(updateIcedDataStart(payload, () => {
        dispatch(getIcedTableData());
        resetForm();
      }));
    }


    console.log("Submitted data:", payload);
  };

  const IcedTicketstableHeaders = icedTableData.length > 0
    ? Object.keys(icedTableData[0]).filter(header =>
      !['AgentID', 'AccountID', 'Ipaddress'].includes(header)
    )
    : [];




  console.log('countryOptions', countryOptions)
  console.log('selectedCountry', selectedServiceTower, selectedAccount?.AccountID, selectedCountry?.CountryID, selectedLanguage?.LanguageID)
  return (
    <div className="Iced_Layout">
      <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/icedapplications')} label2='ICED' isActive3={false} label3='ICED Application' />

      {/* Timer */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          width: "100%",       
          textAlign: "center", 
        }}
      >
        <span>Timer: {formatTime(seconds)}</span>
        <button onClick={handleStart} disabled={isRunning} style={{ marginRight: "10px" }} className={isRunning ? "btn_disabled" : "btn_enabled"}>Start</button>
        <button onClick={handlePause} disabled={!isRunning} className={!isRunning ? "btn_disabled" : "btn_enabled"}>Pause</button>
      </div>
{ validation && <div className='validation-error'>{validation}</div>}

      {/* Dropdowns */}
      <Box display="flex" gap={20} marginTop={2} style={{ gap: '20px' }}>
        {/* <SingleSelectDropdown
          options={countryOptions}
          value={selectedCountry}
          onChange={(val) => {
            setSelectedCountry(val);
            setSelectedAccount("");
            setSelectedLanguage(null);
          }}
          placeholder="Select a Country"
          searchQuery={searchQuery.country}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, country: e.target.value })}
          disabled={!isRunning}
        /> */}

        <SingleSelectDropdown
          options={countryOptions}
          value={selectedCountry}
          onChange={(obj) => setSelectedCountry(obj)} // gets full object now
          placeholder="Select a Country"
          returnType="object"
          disabled={!isRunning}
          searchQuery={searchQuery.country}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, country: e.target.value })}
        />

        {/* <SingleSelectDropdown
          options={accountOptions}
          value={selectedAccount}
          onChange={(val) => {
            setSelectedAccount(val);
            setSelectedLanguage(null);
          }}
          placeholder="Select an Account"
          searchQuery={searchQuery.account}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, account: e.target.value })}
          disabled={!isRunning}
        /> */}

        <SingleSelectDropdown
          options={accountOptions}
          value={selectedAccount}
          onChange={(obj) => setSelectedAccount(obj)} // gets full object now
          placeholder="Select an Account"
          returnType="object"
          disabled={!isRunning}
          searchQuery={searchQuery.account}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, account: e.target.value })}
        />


        {/* <SingleSelectDropdown
          options={serviceTowerOptions}
          value={selectedServiceTower}
          onChange={setSelectedServiceTower}
          placeholder="Select Service Tower"
          searchQuery={searchQuery.serviceTower}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, serviceTower: e.target.value })}
          disabled={!isRunning}
        /> */}

        <SingleSelectDropdown
          options={serviceTowerOptions}
          value={selectedServiceTower}
          onChange={(val) => setSelectedServiceTower(val)} // returns string
          placeholder="Select Service Tower"
          returnType="string"
          searchQuery={searchQuery.serviceTower}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, serviceTower: e.target.value })}
          disabled={!isRunning}
        />



        {/* <SingleSelectDropdown
          options={languageDropdownOptions}
          value={selectedLanguage?.id || ''}
          onChange={(val) => {
            const langObj = languageDropdownOptions.find((l) => l.id === val.id);
            setSelectedLanguage(langObj || null);
          }}
          placeholder="Select Language"
          searchQuery={searchQuery.language}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, language: e.target.value })}
          disabled={!isRunning}
        /> */}

        <SingleSelectDropdown
          options={languageDropdownOptions}
          value={selectedLanguage}
          onChange={(obj) => setSelectedLanguage(obj)} // gets full object now
          returnType="object"
          disabled={!isRunning}
          placeholder="Select Language"
          searchQuery={searchQuery.language}
          onSearchQueryChange={(e) => setSearchQuery({ ...searchQuery, language: e.target.value })}
        />

        <TextField
          variant="outlined"
          placeholder="Enter Ticket Number"
          value={selectedTicketNumber}
          onChange={(e) => setSelectedTicketNumber(e.target.value)}
          style={{ width: 180, font: '12px', height: 24 }}
          InputProps={{ style: { fontSize: '12px', padding: '2px 2px', height: 24, lineHeight: 1.3 } }}
          disabled={!isRunning}
        />
      </Box>

      {/* Channel Section */}
      <div style={{ display: "flex", marginTop: 10, gap: "20px" }}>
        <div className="Radio_title">Channel</div>
        <div style={{ display: "flex", gap: "15px", fontSize: "12px" }}>
          {channels.map((channel) => (
            <label key={channel.ChannelName} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", fontWeight: 400, color: isRunning ? "black" : "gray", }}>
              <input
                type="radio"
                name="channel"
                value={channel.ChannelName}
                checked={selectedChannel === channel.ChannelName}
                onChange={(e) => setSelectedChannel(e.target.value)}
                style={{ width: "10px", height: "10px", cursor:"pointer" }}
                disabled={!isRunning}
              />
              {channel.ChannelName}
            </label>
          ))}
        </div>
      </div>

      {/* Channel Values */}
      {selectedChannel && (
        <div style={{ marginTop: "10px", display: "flex", gap: 20 }}>
          <div className="Radio_title">Value for {selectedChannel}</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", fontSize: "12px" }}>
            {channelData?.ChannelValues.map((val) => (
              <label key={val.ChannelValue} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", fontWeight: 400, color: isRunning ? "black" : "gray", }}>
                <input
                  type="radio"
                  name="channelValue"
                  value={val.ChannelValue}
                  checked={selectedValue === val.ChannelValue}
                  onChange={(e) => setSelectedValue(e.target.value)}
                  style={{ width: "10px", height: "10px", cursor:"pointer" }}
                  disabled={!isRunning}
                />
                {val.ChannelValue}
              </label>
            ))}
          </div>
        </div>
      )}

      {/* Ticket Source */}
      <div style={{ display: "flex", marginTop: 10, gap: "20px" }}>
        <div className="Radio_title">Ticket Source</div>
        <div style={{ display: "flex", gap: "15px", fontSize: "12px" }}>
          {ticketSources.map((src) => (
            <label key={src.TicketSource} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", fontWeight: 400, color: isRunning ? "black" : "gray", }}>
              <input
                type="radio"
                name="ticketSource"
                value={src.TicketSource}
                checked={selectedTicketSource === src.TicketSource}
                onChange={(e) => setSelectedTicketSource(e.target.value)}
                style={{ width: "10px", height: "10px", cursor:"pointer" }}
                disabled={!isRunning}
              />
              {src.TicketSource}
            </label>
          ))}
        </div>
      </div>

      {/* Contact Type */}
      <div style={{ display: "flex", marginTop: 10, gap: "20px" }}>
        <div className="Radio_title">Contact type </div>
        <div style={{ display: "flex", gap: "15px", fontSize: "12px" }}>
          {contactType.map((src) => (
            <label key={src.CType} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", fontWeight: 400, color: isRunning ? "black" : "gray", }}>
              <input
                type="radio"
                name="contactType"
                value={src.CType}
                checked={selectedContactType === src.CType}
                onChange={(e) => setSelectedContactType(e.target.value)}
                style={{ width: "10px", height: "10px", cursor:"pointer" }}
                disabled={!isRunning}
              />
              {src.CType}
            </label>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button onClick={() => { isRunning && handleSubmit() }} className={!isRunning ? "btn_disabled" : "btn_enabled"}>Submit</button>
      </div>

      <div className="aquaa-table-container">
        <table className="aquaa-table">
          <thead>
            <tr>
              {IcedTicketstableHeaders.map((col, index) => (
                <th key={index} style={{ fontSize: '10px' }}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {icedTableData && icedTableData.length > 0 && (
              icedTableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {IcedTicketstableHeaders.map((col, colIndex) => {
                    const cellData = row[col]; // Get the data for this column in the current row

                  if (col === 'Start Date' || col === 'End Date') {
  const date = new Date(cellData);
  const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

  return <td key={colIndex} style={{ fontSize: '10px' }}>{formattedDate}</td>;
}

                    return (
                      <td key={colIndex} style={{ fontSize: '10px' }}>
                        {cellData}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default Iced;
